import * as constants from '../constants'

export const setWebsocketClient = (client) => {
  return {
    type: constants.SET_WEBSOCKET_CLIENT,
    client,
  }
}
